// extracted by mini-css-extract-plugin
module.exports = {"container":"MembersOnlyBadge_container__3aphf","hasAccess":"MembersOnlyBadge_hasAccess__1Qjic"};